import { jsxs as h, jsx as l } from "react/jsx-runtime";
function e() {
  return /* @__PURE__ */ h(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "50 0 250 420",
      width: "40",
      height: "40",
      children: [
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "a", children: /* @__PURE__ */ l("path", { fill: "none", d: "M0 0h544.25v668.98H0z" }) }) }),
        /* @__PURE__ */ h("g", { clipPath: "url(#a)", transform: "scale(0.9),translate(30,30)", children: [
          /* @__PURE__ */ l(
            "path",
            {
              d: "M107.26 23.36V9.9L81.84 0v315.32C35.12 319.65.04 342.84.04 370.2c0 30.39 42.3 55 94.52 55s94.51-24.6 94.51-55c0-27.36-35.39-50.52-81.81-54.88V145.24h190.32V23.36zm55.26 346.88c0 19-30.46 34.45-68 34.45s-68.05-15.41-68.05-34.45 30.41-34.49 67.98-34.49 68 15.42 68 34.47",
              fill: "#00478d",
              fillRule: "evenodd"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M50.09 273.14c0-4.84-3.56-6.31-7.8-6.31h-8.03v20.74h4.58v-8.3h2.27l4.32 8.3h5.49l-5.27-8.75c2.93-.53 4.46-2.79 4.46-5.68m-8.59 2.28h-2.68v-4.74h3c1.67 0 3.54.33 3.54 2.42 0 2.26-2.17 2.32-3.86 2.32",
              fill: "#00478d"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M41.93 257.16a20.37 20.37 0 1 0 20.33 20.37 20.37 20.37 0 0 0-20.34-20.37m0 36.72a16.35 16.35 0 1 1 16.34-16.35 16.38 16.38 0 0 1-16.32 16.35",
              fill: "#00478d"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M107.26 68.75h51.76v-41.4h-51.76zm82.8 0h103.52v-41.4H190.02zm-82.8 72.49h51.76V99.81h-51.76zm82.8 0h103.52V99.81H190.02z",
              fill: "#fff",
              fillRule: "evenodd"
            }
          )
        ] })
      ]
    }
  );
}
export {
  e as default
};
